import { Link } from 'react-router-dom';
import { ShieldX, Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const UnauthorizedPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <div className="flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="w-full max-w-md space-y-8">
          <Card className="shadow-medium">
            <CardHeader className="text-center pb-4">
              <div className="mx-auto mb-4 rounded-full bg-destructive/10 p-4 w-fit">
                <ShieldX className="h-8 w-8 text-destructive" />
              </div>
              <CardTitle className="text-xl">Access Denied</CardTitle>
              <CardDescription className="mt-2">
                You don't have permission to access this page. Please contact your
                administrator if you believe this is an error.
              </CardDescription>
            </CardHeader>
            <CardContent className="flex flex-col gap-2">
              <Link to="/dashboard">
                <Button className="w-full gap-2">
                  <Home className="h-4 w-4" />
                  Go to Dashboard
                </Button>
              </Link>
              <Button 
                variant="outline" 
                className="w-full gap-2"
                onClick={() => history.back()}
              >
                <ArrowLeft className="h-4 w-4" />
                Go Back
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>

      <footer className="py-6 text-center">
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} My Professional Tax. All rights reserved.
        </p>
      </footer>
    </div>
  );
};
